var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "b-card",
        [
          _c(
            "b-card-body",
            [
              _c(
                "b-row",
                { staticClass: "mb-2" },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-end",
                      attrs: { md: "12" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "primary" },
                          on: { click: _vm.showAddVehicleModal },
                        },
                        [
                          _c("feather-icon", {
                            staticClass: "mr-50",
                            attrs: { icon: "PlusIcon" },
                          }),
                          _vm._v(" New Vehicle "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "my-1",
                      attrs: { cols: "12", md: "2", sm: "1" },
                    },
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "mb-0" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "d-inline-block text-sm-left mr-50",
                            },
                            [_vm._v("Per page")]
                          ),
                          _c("b-form-select", {
                            attrs: {
                              id: "perPageSelect",
                              size: "sm",
                              options: _vm.pageOptions,
                            },
                            model: {
                              value: _vm.perPage,
                              callback: function ($$v) {
                                _vm.perPage = $$v
                              },
                              expression: "perPage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-end mb-2",
                      staticStyle: { position: "relative", "z-index": "1" },
                      attrs: { cols: "12" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "outline-danger" },
                          on: { click: _vm.clearFilters },
                        },
                        [_vm._v(" Clear Filters ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-table", {
                        attrs: {
                          hover: "",
                          responsive: "",
                          items: _vm.filteredVehicles,
                          fields: _vm.vehicleFields,
                          "per-page": _vm.perPage,
                          "current-page": _vm.currentPage,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "head(licensePlate)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c("span", [_vm._v("License Plate")]),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder: "Search License Plate",
                                        size: "sm",
                                      },
                                      model: {
                                        value: _vm.filters.licensePlate,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filters,
                                            "licensePlate",
                                            $$v
                                          )
                                        },
                                        expression: "filters.licensePlate",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(make)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c("span", [_vm._v("Vehicle Make")]),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder: "Search Make",
                                        size: "sm",
                                      },
                                      model: {
                                        value: _vm.filters.make,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.filters, "make", $$v)
                                        },
                                        expression: "filters.make",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(color)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c("span", [_vm._v("Vehicle Color")]),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder: "Search Color",
                                        size: "sm",
                                      },
                                      model: {
                                        value: _vm.filters.color,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.filters, "color", $$v)
                                        },
                                        expression: "filters.color",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(model)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c("span", [_vm._v("Vehicle Model")]),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder: "Search Model",
                                        size: "sm",
                                      },
                                      model: {
                                        value: _vm.filters.model,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.filters, "model", $$v)
                                        },
                                        expression: "filters.model",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(year)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c("span", [_vm._v("Vehicle Year")]),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder: "Search Year",
                                        size: "sm",
                                        type: "number",
                                      },
                                      model: {
                                        value: _vm.filters.year,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.filters, "year", $$v)
                                        },
                                        expression: "filters.year",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(odometerReading)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c("span", [_vm._v("Odometer Reading")]),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder: "Search Odometer Reading",
                                        size: "sm",
                                      },
                                      model: {
                                        value: _vm.filters.odometerReading,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filters,
                                            "odometerReading",
                                            $$v
                                          )
                                        },
                                        expression: "filters.odometerReading",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(nextMaintenanceDue)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c("span", [
                                      _vm._v("Next Maintenance Due"),
                                    ]),
                                    _c("DatePicker", {
                                      staticStyle: { width: "150px" },
                                      attrs: {
                                        range: "",
                                        format: "YYYY-MM-DD",
                                        placeholder: "Select date range",
                                      },
                                      model: {
                                        value:
                                          _vm.filters.nextMaintenanceDueRange,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filters,
                                            "nextMaintenanceDueRange",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "filters.nextMaintenanceDueRange",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(insuranceExpiryDate)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c("span", [
                                      _vm._v("Insurance Expiry Date"),
                                    ]),
                                    _c("DatePicker", {
                                      staticStyle: { width: "150px" },
                                      attrs: {
                                        type: "date",
                                        range: "",
                                        format: "YYYY-MM-DD",
                                        placeholder: "Select date range",
                                      },
                                      model: {
                                        value:
                                          _vm.filters.insuranceExpiryDateRange,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filters,
                                            "insuranceExpiryDateRange",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "filters.insuranceExpiryDateRange",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(gpsDeviceID)",
                            fn: function (data) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.getDeviceName(data.item.gpsDeviceID)
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(insuranceExpiryDate)",
                            fn: function (data) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.convertTimestampToDate(
                                        data.item.insuranceExpiryDate
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(nextMaintenanceDue)",
                            fn: function (data) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.convertTimestampToDate(
                                        data.item.nextMaintenanceDue
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(odometerReading)",
                            fn: function (data) {
                              return [
                                _vm._v(
                                  " " + _vm._s(data.item.odometerReading) + " "
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(actions)",
                            fn: function (data) {
                              return [
                                _c(
                                  "b-dropdown",
                                  {
                                    staticClass: "m-1",
                                    attrs: {
                                      variant: "link",
                                      "toggle-class": "p-0",
                                      "no-caret": "",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "button-content",
                                          fn: function () {
                                            return [
                                              _c("feather-icon", {
                                                staticClass:
                                                  "align-middle text-body",
                                                attrs: {
                                                  icon: "MoreVerticalIcon",
                                                  size: "16",
                                                },
                                              }),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.showViewVehicleModal(
                                              data.item
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "EyeIcon" },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "align-middle ml-1" },
                                          [_vm._v("View")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.showEditVehicleModal(
                                              data.item
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "EditIcon" },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "align-middle ml-1" },
                                          [_vm._v("Edit")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.confirmDeleteVehicle(
                                              data.item.vehicleId
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "TrashIcon" },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "align-middle ml-1" },
                                          [_vm._v("Delete")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-center mb-1" },
                        [
                          _vm.loading
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-center mb-1",
                                },
                                [
                                  _c("b-spinner", {
                                    staticStyle: {
                                      width: "3rem",
                                      height: "3rem",
                                    },
                                    attrs: {
                                      variant: "success",
                                      label: "Spinning",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-pagination", {
                        staticClass: "my-0",
                        attrs: {
                          "total-rows": _vm.totalRows,
                          "per-page": _vm.perPage,
                          align: "center",
                          size: "sm",
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function ($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage",
                        },
                      }),
                      _c("b-form-group", [
                        _vm._v(
                          " Showing " +
                            _vm._s(
                              _vm.totalRows > 0
                                ? _vm.perPage * (_vm.currentPage - 1) + 1
                                : 0
                            ) +
                            " to " +
                            _vm._s(
                              _vm.totalRows > 0
                                ? Math.min(
                                    _vm.perPage * _vm.currentPage,
                                    _vm.totalRows
                                  )
                                : 0
                            ) +
                            " of " +
                            _vm._s(_vm.totalRows > 0 ? _vm.totalRows : 0) +
                            " entries "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-modal",
                {
                  ref: "modalViewVehicle",
                  attrs: {
                    id: "modal-view-vehicle",
                    title: "View Vehicle",
                    "hide-footer": "",
                    centered: "",
                  },
                },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "License Plate",
                        "label-for": "licensePlate",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { id: "licensePlate", readonly: "" },
                        model: {
                          value: _vm.viewVehicle.licensePlate,
                          callback: function ($$v) {
                            _vm.$set(_vm.viewVehicle, "licensePlate", $$v)
                          },
                          expression: "viewVehicle.licensePlate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    { attrs: { label: "Make", "label-for": "make" } },
                    [
                      _c("b-form-input", {
                        attrs: { id: "make", readonly: "" },
                        model: {
                          value: _vm.viewVehicle.make,
                          callback: function ($$v) {
                            _vm.$set(_vm.viewVehicle, "make", $$v)
                          },
                          expression: "viewVehicle.make",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    { attrs: { label: "Color", "label-for": "color" } },
                    [
                      _c("b-form-input", {
                        attrs: { id: "color", readonly: "" },
                        model: {
                          value: _vm.viewVehicle.color,
                          callback: function ($$v) {
                            _vm.$set(_vm.viewVehicle, "color", $$v)
                          },
                          expression: "viewVehicle.color",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    { attrs: { label: "Model", "label-for": "model" } },
                    [
                      _c("b-form-input", {
                        attrs: { id: "model", readonly: "" },
                        model: {
                          value: _vm.viewVehicle.model,
                          callback: function ($$v) {
                            _vm.$set(_vm.viewVehicle, "model", $$v)
                          },
                          expression: "viewVehicle.model",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    { attrs: { label: "Year", "label-for": "year" } },
                    [
                      _c("b-form-input", {
                        attrs: { id: "year", type: "number", readonly: "" },
                        model: {
                          value: _vm.viewVehicle.year,
                          callback: function ($$v) {
                            _vm.$set(_vm.viewVehicle, "year", $$v)
                          },
                          expression: "viewVehicle.year",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Odometer Reading",
                        "label-for": "odometerReading",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "odometerReading",
                          type: "number",
                          readonly: "",
                        },
                        model: {
                          value: _vm.viewVehicle.odometerReading,
                          callback: function ($$v) {
                            _vm.$set(_vm.viewVehicle, "odometerReading", $$v)
                          },
                          expression: "viewVehicle.odometerReading",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Litres Consumed",
                        "label-for": "litresConsumed",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "litresConsumed",
                          type: "number",
                          readonly: "",
                        },
                        model: {
                          value: _vm.viewVehicle.litresConsumed,
                          callback: function ($$v) {
                            _vm.$set(_vm.viewVehicle, "litresConsumed", $$v)
                          },
                          expression: "viewVehicle.litresConsumed",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Kilometers Travelled",
                        "label-for": "kilometersTravelled",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "kilometersTravelled",
                          type: "number",
                          readonly: "",
                        },
                        model: {
                          value: _vm.viewVehicle.kilometersTravelled,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.viewVehicle,
                              "kilometersTravelled",
                              $$v
                            )
                          },
                          expression: "viewVehicle.kilometersTravelled",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Last Maintenance Date",
                        "label-for": "lastMaintenanceDate",
                      },
                    },
                    [
                      _c("b-form-datepicker", {
                        attrs: {
                          id: "lastMaintenanceDate",
                          type: "date",
                          disabled: "",
                        },
                        model: {
                          value: _vm.viewVehicle.lastMaintenanceDate,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.viewVehicle,
                              "lastMaintenanceDate",
                              $$v
                            )
                          },
                          expression: "viewVehicle.lastMaintenanceDate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Next Maintenance Due",
                        "label-for": "nextMaintenanceDue",
                      },
                    },
                    [
                      _c("b-form-datepicker", {
                        attrs: {
                          id: "nextMaintenanceDue",
                          type: "date",
                          disabled: "",
                        },
                        model: {
                          value: _vm.viewVehicle.nextMaintenanceDue,
                          callback: function ($$v) {
                            _vm.$set(_vm.viewVehicle, "nextMaintenanceDue", $$v)
                          },
                          expression: "viewVehicle.nextMaintenanceDue",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Insurance Policy Number",
                        "label-for": "insurancePolicyNumber",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { id: "insurancePolicyNumber", readonly: "" },
                        model: {
                          value: _vm.viewVehicle.insurancePolicyNumber,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.viewVehicle,
                              "insurancePolicyNumber",
                              $$v
                            )
                          },
                          expression: "viewVehicle.insurancePolicyNumber",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Insurance Expiry Date",
                        "label-for": "insuranceExpiryDate",
                      },
                    },
                    [
                      _c("b-form-datepicker", {
                        attrs: {
                          id: "insuranceExpiryDate",
                          type: "date",
                          disabled: "",
                        },
                        model: {
                          value: _vm.viewVehicle.insuranceExpiryDate,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.viewVehicle,
                              "insuranceExpiryDate",
                              $$v
                            )
                          },
                          expression: "viewVehicle.insuranceExpiryDate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "GPS Device",
                        "label-for": "gpsDeviceID",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "viewGPSDeviceID",
                          value: _vm.getDeviceName(_vm.viewVehicle.gpsDeviceID),
                          readonly: "",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("CustomFieldsDetails", {
                    attrs: {
                      AdditionalFields: _vm.viewVehicle.additionalFields,
                      ReadOnlyFields: true,
                      ModuleReference: "Vehicle",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-modal",
                {
                  ref: "addVehicleModal",
                  attrs: {
                    id: "modal-add-vehicle",
                    title: "Add New Vehicle",
                    "hide-footer": "",
                    centered: "",
                  },
                  on: {
                    ok: function ($event) {
                      $event.preventDefault()
                      return _vm.addNewVehicle($event)
                    },
                  },
                },
                [
                  _c("validation-observer", {
                    ref: "addVehicleForm",
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var invalid = ref.invalid
                          return [
                            _c(
                              "b-form",
                              {
                                on: {
                                  submit: function ($event) {
                                    $event.preventDefault()
                                    return _vm.addNewVehicle($event)
                                  },
                                },
                              },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "License Plate",
                                      "label-for": "licensePlate",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "License Plate",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: { id: "licensePlate" },
                                                  model: {
                                                    value:
                                                      _vm.newVehicle
                                                        .licensePlate,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newVehicle,
                                                        "licensePlate",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newVehicle.licensePlate",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Make",
                                      "label-for": "make",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Make",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: { id: "make" },
                                                  model: {
                                                    value: _vm.newVehicle.make,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newVehicle,
                                                        "make",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newVehicle.make",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Color",
                                      "label-for": "color",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: { name: "Color" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: { id: "color" },
                                                  model: {
                                                    value: _vm.newVehicle.color,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newVehicle,
                                                        "color",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newVehicle.color",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Model",
                                      "label-for": "model",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Model",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: { id: "model" },
                                                  model: {
                                                    value: _vm.newVehicle.model,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newVehicle,
                                                        "model",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newVehicle.model",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Year",
                                      "label-for": "year",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Year",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "year",
                                                    type: "number",
                                                    min: "1900",
                                                  },
                                                  model: {
                                                    value: _vm.newVehicle.year,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newVehicle,
                                                        "year",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newVehicle.year",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Odometer Reading",
                                      "label-for": "odometerReading",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Odometer Reading",
                                        rules: "numeric|min:0",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "odometerReading",
                                                    type: "number",
                                                    min: "0",
                                                  },
                                                  on: {
                                                    keypress: function (
                                                      $event
                                                    ) {
                                                      return _vm.allowOnlyNumbers(
                                                        $event
                                                      )
                                                    },
                                                    input: function ($event) {
                                                      return _vm.sanitizeInput(
                                                        "odometerReading"
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newVehicle
                                                        .odometerReading,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newVehicle,
                                                        "odometerReading",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newVehicle.odometerReading",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Litres Consumed",
                                      "label-for": "litresConsumed",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Litres Consumed",
                                        rules: "numeric|min:0",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "litresConsumed",
                                                    type: "number",
                                                    min: "0",
                                                  },
                                                  on: {
                                                    keypress: function (
                                                      $event
                                                    ) {
                                                      return _vm.allowOnlyNumbers(
                                                        $event
                                                      )
                                                    },
                                                    input: function ($event) {
                                                      return _vm.sanitizeInput(
                                                        "litresConsumed"
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newVehicle
                                                        .litresConsumed,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newVehicle,
                                                        "litresConsumed",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newVehicle.litresConsumed",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Kilometers Travelled",
                                      "label-for": "kilometersTravelled",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Kilometers Travelled",
                                        rules: "numeric|min:0",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "kilometersTravelled",
                                                    type: "number",
                                                    min: "0",
                                                  },
                                                  on: {
                                                    keypress: function (
                                                      $event
                                                    ) {
                                                      return _vm.allowOnlyNumbers(
                                                        $event
                                                      )
                                                    },
                                                    input: function ($event) {
                                                      return _vm.sanitizeInput(
                                                        "kilometersTravelled"
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newVehicle
                                                        .kilometersTravelled,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newVehicle,
                                                        "kilometersTravelled",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newVehicle.kilometersTravelled",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Last Maintenance Date",
                                      "label-for": "lastMaintenanceDate",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Last Maintenance Date",
                                        rules: {
                                          dateCheck: {
                                            nextDate:
                                              _vm.newVehicle.nextMaintenanceDue,
                                          },
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "lastMaintenanceDate",
                                                    type: "date",
                                                    max: _vm.currentDate,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newVehicle
                                                        .lastMaintenanceDate,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newVehicle,
                                                        "lastMaintenanceDate",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newVehicle.lastMaintenanceDate",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Next Maintenance Due",
                                      "label-for": "nextMaintenanceDue",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Next Maintenance Due",
                                        rules: "futureDateCheck",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "nextMaintenanceDue",
                                                    type: "date",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newVehicle
                                                        .nextMaintenanceDue,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newVehicle,
                                                        "nextMaintenanceDue",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newVehicle.nextMaintenanceDue",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Insurance Policy Number",
                                      "label-for": "insurancePolicyNumber",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Insurance Policy Number",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "insurancePolicyNumber",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newVehicle
                                                        .insurancePolicyNumber,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newVehicle,
                                                        "insurancePolicyNumber",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newVehicle.insurancePolicyNumber",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Insurance Expiry Date*",
                                      "label-for": "insuranceExpiryDate",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Insurance Expiry Date",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "insuranceExpiryDate",
                                                    type: "date",
                                                    min: _vm.currentDate,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newVehicle
                                                        .insuranceExpiryDate,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newVehicle,
                                                        "insuranceExpiryDate",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newVehicle.insuranceExpiryDate",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "GPS Device",
                                      "label-for": "gpsDeviceID",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: { name: "GPS Device" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-select", {
                                                  attrs: {
                                                    id: "gpsDeviceID",
                                                    options:
                                                      _vm.gpsDeviceOptions,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newVehicle
                                                        .gpsDeviceId,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newVehicle,
                                                        "gpsDeviceId",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newVehicle.gpsDeviceId",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c("CustomFieldsDetails", {
                                  attrs: {
                                    AdditionalFields:
                                      _vm.newVehicle.additionalFields,
                                    ModuleReference: "Vehicle",
                                  },
                                  on: { onchange: _vm.additionalFieldChanges },
                                }),
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      type: "button",
                                      variant: "primary",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.addNewVehicle()
                                      },
                                    },
                                  },
                                  [_vm._v("Add Vehicle")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "b-modal",
                {
                  ref: "modalEditVehicle",
                  attrs: {
                    id: "modal-edit-vehicle",
                    title: "Edit Vehicle",
                    "hide-footer": "",
                    centered: "",
                  },
                },
                [
                  _c("validation-observer", {
                    ref: "editVehicleForm",
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var invalid = ref.invalid
                          var validate = ref.validate
                          return [
                            _c(
                              "b-form",
                              {
                                on: {
                                  submit: function ($event) {
                                    $event.preventDefault()
                                  },
                                },
                              },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "License Plate",
                                      "label-for": "editLicensePlate",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "License Plate",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "editLicensePlate",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editVehicle
                                                        .licensePlate,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editVehicle,
                                                        "licensePlate",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editVehicle.licensePlate",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Make",
                                      "label-for": "editMake",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Make",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: { id: "editMake" },
                                                  model: {
                                                    value: _vm.editVehicle.make,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editVehicle,
                                                        "make",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editVehicle.make",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Color",
                                      "label-for": "editColor",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: { name: "Color" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: { id: "editColor" },
                                                  model: {
                                                    value:
                                                      _vm.editVehicle.color,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editVehicle,
                                                        "color",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editVehicle.color",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Model",
                                      "label-for": "editModel",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Model",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: { id: "editModel" },
                                                  model: {
                                                    value:
                                                      _vm.editVehicle.model,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editVehicle,
                                                        "model",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editVehicle.model",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Year",
                                      "label-for": "editYear",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Year",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "editYear",
                                                    type: "number",
                                                    min: "0",
                                                  },
                                                  model: {
                                                    value: _vm.editVehicle.year,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editVehicle,
                                                        "year",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editVehicle.year",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Odometer Reading",
                                      "label-for": "editOdometerReading",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: { name: "Odometer Reading" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "editOdometerReading",
                                                    type: "number",
                                                    min: "0",
                                                  },
                                                  on: {
                                                    keypress: function (
                                                      $event
                                                    ) {
                                                      return _vm.allowOnlyNumbers(
                                                        $event
                                                      )
                                                    },
                                                    input: function ($event) {
                                                      return _vm.sanitizeInput(
                                                        "odometerReading"
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editVehicle
                                                        .odometerReading,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editVehicle,
                                                        "odometerReading",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editVehicle.odometerReading",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Litres Consumed",
                                      "label-for": "editLitresConsumed",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "LitresConsumed",
                                        rules: "numeric|min:0",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "editLitresConsumed",
                                                    type: "number",
                                                    min: "0",
                                                  },
                                                  on: {
                                                    keypress: function (
                                                      $event
                                                    ) {
                                                      return _vm.allowOnlyNumbers(
                                                        $event
                                                      )
                                                    },
                                                    input: function ($event) {
                                                      return _vm.sanitizeInput(
                                                        "litresConsumed"
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editVehicle
                                                        .litresConsumed,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editVehicle,
                                                        "litresConsumed",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editVehicle.litresConsumed",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Kilometers Travelled",
                                      "label-for": "editKilometersTravelled",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "KilometersTravelled",
                                        rules: "numeric|min:0",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "editKilometersTravelled",
                                                    type: "number",
                                                    min: "0",
                                                  },
                                                  on: {
                                                    keypress: function (
                                                      $event
                                                    ) {
                                                      return _vm.allowOnlyNumbers(
                                                        $event
                                                      )
                                                    },
                                                    input: function ($event) {
                                                      return _vm.sanitizeInput(
                                                        "kilometersTravelled"
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editVehicle
                                                        .kilometersTravelled,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editVehicle,
                                                        "kilometersTravelled",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editVehicle.kilometersTravelled",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Last Maintenance Date",
                                      "label-for": "editLastMaintenanceDate",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: { name: "Last Maintenance Date" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-datepicker", {
                                                  attrs: {
                                                    id: "editLastMaintenanceDate",
                                                    type: "date",
                                                    max: _vm.currentDate,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editVehicle
                                                        .lastMaintenanceDate,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editVehicle,
                                                        "lastMaintenanceDate",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editVehicle.lastMaintenanceDate",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Next Maintenance Due",
                                      "label-for": "editNextMaintenanceDue",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: { name: "Next Maintenance Due" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-datepicker", {
                                                  attrs: {
                                                    id: "editNextMaintenanceDue",
                                                    type: "date",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editVehicle
                                                        .nextMaintenanceDue,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editVehicle,
                                                        "nextMaintenanceDue",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editVehicle.nextMaintenanceDue",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Insurance Policy Number",
                                      "label-for": "editInsurancePolicyNumber",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Insurance Policy Number",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "editInsurancePolicyNumber",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editVehicle
                                                        .insurancePolicyNumber,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editVehicle,
                                                        "insurancePolicyNumber",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editVehicle.insurancePolicyNumber",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Insurance Expiry Date",
                                      "label-for": "editInsuranceExpiryDate",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: { name: "Insurance Expiry Date" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-datepicker", {
                                                  attrs: {
                                                    id: "editInsuranceExpiryDate",
                                                    type: "date",
                                                    min: _vm.currentDate,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editVehicle
                                                        .insuranceExpiryDate,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editVehicle,
                                                        "insuranceExpiryDate",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editVehicle.insuranceExpiryDate",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "GPS Device",
                                      "label-for": "editGPSDeviceID",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: { name: "GPS Device" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-select", {
                                                  attrs: {
                                                    id: "editGPSDeviceID",
                                                    options:
                                                      _vm.gpsDeviceOptions,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editVehicle
                                                        .gpsDeviceID,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editVehicle,
                                                        "gpsDeviceID",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editVehicle.gpsDeviceID",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c("CustomFieldsDetails", {
                                  attrs: {
                                    AdditionalFields:
                                      _vm.editVehicle.additionalFields,
                                    ModuleReference: "Vehicle",
                                  },
                                  on: {
                                    onchange: _vm.additionalFieldChangesedit,
                                  },
                                }),
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      type: "submit",
                                      variant: "primary",
                                      disabled: invalid,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.updateVehicle()
                                      },
                                    },
                                  },
                                  [_vm._v("Update Vehicle")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }